import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateVendorContact } from '../../../state/vendorSlice';

const SecondaryContactNameEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentVendor } = useAppSelector(state => state.vendor);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateVendorContact({ secondaryContactName: event.target.value }));
  };

  return (
    <TextField
      label="Contact Name"
      size="small"
      fullWidth
      value={currentVendor?.secondaryContactName || ''}
      onChange={handleChange}
    />
  );
};

export default SecondaryContactNameEdit;
